export { default as DataIcon } from './component';
